/**
 * 電話番号を正規化する（比較用）
 * - ハイフン・スペース・括弧を除去
 * - +81 → 0（日本国番号）
 * - 空文字列 → 空文字列（呼び出し側で null チェック）
 *
 * SQL版 (normalize_phone) と同一ロジック
 */
export function normalizePhone(phone: string | null | undefined): string {
  if (!phone) return "";
  let digits = phone.trim();
  if (digits === "") return "";
  // 非数字・非+を除去
  digits = digits.replace(/[^0-9+]/g, "");
  // +81 → 0
  if (digits.startsWith("+81")) {
    digits = "0" + digits.slice(3);
  }
  return digits;
}

/**
 * メールアドレスを正規化する（比較用）
 * - 小文字化 + trim
 */
export function normalizeEmail(email: string | null | undefined): string {
  if (!email) return "";
  return email.toLowerCase().trim();
}

/**
 * ひらがなをカタカナに変換する（フリガナ検索の正規化用）
 *
 * U+3041〜U+3096 (ぁ〜ゖ) を U+30A1〜U+30F6 (ァ〜ヶ) に変換する。
 * オフセットは +0x60 で 1:1 対応。長音符号 ー (U+30FC) や漢字・英数字は不変。
 *
 * DB 側 (RPC) の translate() と同じ変換ルールを使う必要があるので、
 * 文字範囲を変えるときは migration の翻訳テーブルも一緒に直すこと。
 */
export function toKatakana(s: string | null | undefined): string {
  if (!s) return "";
  let result = "";
  for (const ch of s) {
    const code = ch.codePointAt(0);
    if (code !== undefined && code >= 0x3041 && code <= 0x3096) {
      result += String.fromCodePoint(code + 0x60);
    } else {
      result += ch;
    }
  }
  return result;
}

/**
 * 検索文字列が「カナを含む」かどうかを判定する。
 * 顧客一覧のフリガナ検索条件を発火するかのゲートに使用する。
 *
 * 対象: ひらがな (U+3041-U+3096)、カタカナ (U+30A1-U+30F6)、長音符号 (U+30FC)
 */
export function isKanaQuery(s: string | null | undefined): boolean {
  if (!s) return false;
  return /[ぁ-ゖァ-ヶー]/.test(s);
}
